import { addRpcUrlOverrideToChain, PrivyClientConfig } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';
import { Chain } from 'viem';

import { SUPPORTED_CHAINS } from '@/constants/chain';
import { JWT_PROTECTED_JSON_RPC_HTTP_URL_BY_CHAIN_ID } from '@/constants/rpc';

import { ENV } from '@/environment/client';

import { routes } from './routes';

export const PRIVY_ID = ENV.NEXT_PUBLIC_PRIVY_ID;

export const PRIVY_CLIENT_ID = ENV.NEXT_PUBLIC_PRIVY_CLIENT_ID;

const walletConnectCloudProjectId = ENV.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID;

const solanaConnectors = toSolanaWalletConnectors({
  // By default, shouldAutoConnect is enabled
  shouldAutoConnect: true,
});

export const config: PrivyClientConfig = {
  // Customize Privy's appearance in your app
  appearance: {
    theme: 'light',
    accentColor: '#00B96D',
    logo: 'https://matcha.xyz/apple-touch-icon.png',
    walletChainType: 'ethereum-and-solana',
    showWalletLoginFirst: true,
  },
  externalWallets: { solana: { connectors: solanaConnectors } },
  // Create embedded wallets for users who don't have a wallet
  // Uncomment when enabling embedded wallets
  // embeddedWallets: {
  //   createOnLogin: 'users-without-wallets',
  //   requireUserPasswordOnCreate: true,
  //   showWalletUIs: false,
  // },
  /** All legal configuration */
  legal: {
    termsAndConditionsUrl: routes.TERMS,
    privacyPolicyUrl: routes.PRIVACY,
  },
  loginMethods: ['wallet'],
  supportedChains: SUPPORTED_CHAINS.map((chain: Chain) =>
    addRpcUrlOverrideToChain(chain, JWT_PROTECTED_JSON_RPC_HTTP_URL_BY_CHAIN_ID[chain.id]),
  ),
  walletConnectCloudProjectId,
};

/**
 * Login methods offered by the "Use Matcha account" chooser path. v1 is
 * email only (no socials, no external wallets — wallets are the other chooser
 * option). Passed as a per-call override to Privy's `login()`; the global
 * `config` stays wallet-only. Privy renders only the intersection of these and
 * the methods enabled in the Privy dashboard, so dashboard config must match.
 */
export const MATCHA_ACCOUNT_LOGIN_METHODS: PrivyClientConfig['loginMethods'] = ['email'];

/** Convert EVM Caip-2 chainId format to number
 *
 * @remarks
 *
 * This function is used to extract the chainId number from the privy chainId format "eip155:1285"
 * https://docs.privy.io/reference/sdk/server-auth/type-aliases/EvmCaip2ChainId
 *
 * @param chainId - privy chainId format
 */
export const getChainIdNumberFromCaip2ChainId = (chainId: string): number =>
  parseInt(chainId.split(':')[1], 10);
